import { BedDouble } from "lucide-react";

export default function AccommodationSection({ wedding }) {
  if (!wedding.alloggi_text?.trim()) return null;
  return (
    <section className="py-16 sm:py-20 px-6 sm:px-12 bg-white" data-testid="accommodation-section">
      <div className="max-w-xl mx-auto text-center">
        <BedDouble size={28} className="mx-auto mb-4" style={{ color: "var(--wed-primary)" }} />
        <p className="eyebrow mb-3">Dove dormire</p>
        <p className="text-neutral-600 leading-relaxed whitespace-pre-line">{wedding.alloggi_text}</p>
      </div>
    </section>
  );
}
